// removed by extract-text-webpack-plugin
module.exports = {"breakpoints":"(\"xs\":0px,\"phone-wide\":560px,\"phablet\":640px,\"tablet-small\":768px,\"tablet\":960px,\"tablet-wide\":1080px,\"desktop\":1280px)"};